module.exports = __webpack_public_path__ + "img/warning-icon.2bf82905.svg";